import React, { Component } from 'react'

export class Loader extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div>
                {
                    (this.props.isLoading) ? (
                        <div>
                            <i style={{ "font-size": "80px", "position": "fixed", "z-index": "1", "top": "35%", "left": "48%" }} className="fa fa-cog fa-spin"></i><br />
                            <b style={{"position": "fixed", "z-index": "1", "top": "50%", "left": "43%", "color": "black"}}>Please wait while we process your request</b>
                        </div>
                    ) : (
                            null
                        )
                }
            </div>
        )
    }
}

export default Loader
